import { Component, EventEmitter, Output } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-cookie-consent-dialog',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './cookie-consent-dialog.component.html',
  styleUrl: './cookie-consent-dialog.component.css',
})
export class CookieConsentDialogComponent {
  constructor(private dialogRef: DialogRef<boolean>) {}

  accept() {
    this.dialogRef.close(true);
  }

  decline() {
    window.top?.close();
    this.dialogRef.close(false);
  }
}
